(() => {
  const ROOT_SELECTOR = 'product-info[data-yeahbox-mobile-pdp-v3]';
  const GALLERY_SELECTOR = '[data-yeahbox-product-media]';
  const controllers = new Map();

  const connect = (root) => {
    if (controllers.has(root)) return;
    const gallery = root.querySelector(GALLERY_SELECTOR);
    if (!gallery) return;

    const selectMedia = (value) => {
      const mediaId = String(value ?? '').trim();
      if (!mediaId) return;
      const exists = Array.from(gallery.querySelectorAll('[data-yeahbox-slide-index][data-yeahbox-media-id]'))
        .some((slide) => slide.dataset.yeahboxMediaId === mediaId);
      if (!exists) return;
      gallery.dispatchEvent(new CustomEvent('yeahbox:select-media', {
        detail: { mediaId }, cancelable: true,
      }));
    };

    const selectFromMarkup = (source) => {
      selectMedia(source?.querySelector(GALLERY_SELECTOR)?.dataset.yeahboxInitialMediaId);
    };

    const handleChange = (event) => {
      const target = event.target;
      const input = target?.tagName === 'SELECT' ? target.selectedOptions?.[0] : target;
      if (!input || !root.contains(input) || (!input.checked && !input.selected)) return;
      selectMedia(input.dataset.yeahboxGalleryTarget);
      if (target.tagName !== 'INPUT' || !input.dataset.optionDisplayLabel) return;
      const caption = input.closest('.product-form__input')?.querySelector('[data-selected-value]');
      if (caption) caption.textContent = input.dataset.optionDisplayLabel;
    };

    const unsubscribe = typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
      ? subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data?.variant || String(data.sectionId) !== String(root.dataset.section)) return;
        selectFromMarkup(data.html?.getElementById(root.id));
      })
      : null;

    root.addEventListener('change', handleChange);
    controllers.set(root, () => {
      root.removeEventListener('change', handleChange);
      unsubscribe?.();
    });
    selectFromMarkup(root);
  };

  const refresh = (scope = document) => {
    controllers.forEach((destroy, root) => {
      if (root.isConnected) return;
      destroy();
      controllers.delete(root);
    });
    if (scope.matches?.(ROOT_SELECTOR)) connect(scope);
    scope.querySelectorAll?.(ROOT_SELECTOR).forEach(connect);
  };

  document.addEventListener('product-info:loaded', (event) => refresh(event.target));
  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((destroy, root) => {
      if (event.target !== root && !event.target.contains(root)) return;
      destroy();
      controllers.delete(root);
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(), { once: true });
  } else {
    refresh();
  }
})();
